exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/wamp64/www/Uclics/demo/angular/src/app/components/error-page/error-page.component.css
// module id = ../../../../../src/app/components/error-page/error-page.component.css
// module chunks = main